import { PremiumsEasyPayAccountType } from '@cms-max/medicare-api-sdk'
import { validateRoutingNumber } from 'containers/Premiums/utils/validateRoutingNumber'
import { TFunction } from 'react-i18next'
import { z } from 'zod'

const tConfig = {
  ns: 'easyPayCommon'
}

export const createSchema = (t: TFunction) => {
  return z
    .object({
      accountType: z.enum([PremiumsEasyPayAccountType.Checking, PremiumsEasyPayAccountType.Savings], {
        required_error: t('accountType.validation', tConfig),
        invalid_type_error: t('accountType.validation', tConfig)
      }),

      routing: z
        .string({
          required_error: t('routing.validation', tConfig)
        })
        .length(9, t('routing.validation', tConfig))
        .refine((value) => validateRoutingNumber(value), {
          message: t('routing.validation', tConfig)
        }),

      accountNumber: z
        .string({
          required_error: t('accountNumber.validation', tConfig)
        })
        .min(4, t('accountNumber.validation', tConfig))
        .max(17, t('accountNumber.validation', tConfig)),

      verifyAccountNumber: z.string().optional(),

      authorization: z.literal(true, {
        // Zod doesn't currently support shorthand messages for `invalid_literal`
        errorMap: () => ({ message: t('authorization.validation', tConfig) })
      })
    })
    .refine((data) => data.accountNumber === data.verifyAccountNumber, {
      message: t('verifyAccountNumber.validation', tConfig),
      path: ['verifyAccountNumber']
    })
}

export type EasyPayEditFormData = z.infer<ReturnType<typeof createSchema>>
